import Card from '../nura/card/card'
import Modal from '../modal/modal'
import Button from '../nura/button/button'
import BaseForm from "../base-form/base-form"

import styles from './styles.module.css'

export default ({ show, setShow, handleDelete }) => {
    return (
        <Modal show={show} onClose={() => setShow(false)}>
            <Card variant="modal" style={{ width: 358 }}>
                <BaseForm onBack={() => setShow(false)} title="Delete">
                    <div className={styles.menuDescription}>
                        <div>Are you sure you want to delete the selected items? </div>
                        <div style={{ marginTop: 15, fontWeight: 500 }}>This action is not reversible.</div>
                    </div>
                    <div className={styles.actionGroup}>
                        <Button style={{ width: '100%' }} variant="error" onClick={handleDelete}>Delete</Button>
                    </div>
                </BaseForm>
            </Card>
        </Modal>
    )
}